export default "__VITE_ASSET__35b0fc69__"